import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { DEFAULT_VAT_PERCENTAGE } from "../../constants/Variables";
import { setActiveTab } from "../../lib/slices/activeTabSlice";
import { fetchSettings } from "../../lib/slices/settingSlice";
import { getAllEcomCategory } from "../../services/ecomCategoryApiFn";
import { getAllEcomSubCategory } from "../../services/ecomSubCategoryApiFn";
import { getAllEcomSubSubCategory } from "../../services/ecomSubSubCategoryApiFn";
import { getAllEcommerceTags } from "../../services/ecommerceTageApiFn";
import {
  createProduct,
  getSingleProductById,
  updateProduct,
  updateVariantStatus,
} from "../../services/productApiFn";
import {
  calculateProductFinalPrice,
  decodeHtml,
  handleOpenSnackBar,
  overAllProductQuantity,
  validateVariants,
} from "../../utils";
import { addEditProductValidation } from "../../utils/Validation";
import AppLoader from "../AppLoader";
import LoadingContainer from "../Containers/LoadingContainer";
import PaperContainer from "../Containers/PaperContainer";
import GlobalButton from "../CustomButton";
import BasicInformation from "./BasicInformation";
import DescriptionAndSpecification from "./Description&Specification";
import Preview from "./Preview";
import Pricing from "./Pricing";
import ProductImages from "./ProductImages";
import ProductTags from "./Tags";
import ProductVariantManager from "./Variant";
import { getBrands } from "../../services/brandApiFn";

const AddEditProduct = ({ handleChangeTab }) => {
  const errorRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation(["products", "common"]);
  const [allCategories, setAllCategories] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [allSubSubCategories, setAllSubSubCategories] = useState([]);
  const [allEcommerceTags, setAllEcommerceTags] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [isloading, setIsLoading] = useState({
    image: false,
    allCategories: false,
    allSubCategories: false,
    allSubSubCategories: false,
    allEcommerceTags: false,
    addProduct: false,
    detail: false,
    updateVariantStatus: false,
  });
  const [previewOpen, setPreviewOpen] = useState(false);
  const [inputError, setInputError] = useState({});
  const [inputValues, setInputValues] = useState({
    type: "Product",
    productType: "normal",
    name_en: "",
    name_ro: "",
    category: "",
    subCategory: "",
    subSubCategory: "",
    description_en: "",
    description_ro: "",
    images: [],
    brand: "",
    quantity: 0,
    price: 0,
    profitMargin: 0,
    discount: 0,
    sku: "",
    specification_en: "",
    specification_ro: "",
    solutionType: [],
    // tags: [],
  });

  // Variants Parts
  const [attributes, setAttributes] = useState([]);
  const [variants, setVariants] = useState([]);

  // Information
  const userData = useSelector((state) => state.userData.user);
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const productId = useSelector(
    (state) => state.detailIdReducer?.detailIds.productId,
  );
  const productPageType = useSelector(
    (state) => state.detailIdReducer?.detailIds.productPageType,
  );
  const { settings, loading: settingsLoading } = useSelector(
    (state) => state.settingsReducer,
  );

  const fetchchedAllCategories = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, allCategories: true }));
      const response = await getAllEcomCategory();
      if (response?.data?.status === "success") {
        setAllCategories(response?.data?.data);
      } else {
        console.error(response?.data?.message, "error");
      }
    } catch (error) {
      console.error(error?.message, "error");
    } finally {
      setIsLoading((prev) => ({ ...prev, allCategories: false }));
    }
  };

  const fetchchedAllSubCategories = async (value) => {
    try {
      setIsLoading((prev) => ({ ...prev, allSubCategories: true }));
      const response = await getAllEcomSubCategory("", value);
      if (response?.data?.status === "success") {
        setAllSubCategories(response?.data?.data);
      } else {
        handleOpenSnackBar(response?.data?.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading((prev) => ({ ...prev, allSubCategories: false }));
    }
  };

  const fetchchedAllSubSubCategories = async (value1, value2) => {
    try {
      setIsLoading((prev) => ({ ...prev, allSubSubCategories: true }));
      const response = await getAllEcomSubSubCategory("", value1, value2);
      if (response?.data?.status === "success") {
        setAllSubSubCategories(response?.data?.data);
      } else {
        handleOpenSnackBar(response?.data?.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading((prev) => ({ ...prev, allSubSubCategories: false }));
    }
  };

  const fetchchAllBrands = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, brands: true }));
      const response = await getBrands({ page: 1, limit: 500 });
      if (response?.data?.status === "success") {
        setAllBrands(response?.data?.data?.data);
      } else {
        handleOpenSnackBar(response?.data?.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading((prev) => ({ ...prev, brands: false }));
    }
  };

  const fetchchedAllEcommerceTags = async (solutionType) => {
    try {
      setIsLoading((prev) => ({ ...prev, allEcommerceTags: true }));
      const params = {
        solutionType: solutionType,
        appliesTo: "product",
      };
      const response = await getAllEcommerceTags(params);
      if (response?.data?.status === "success") {
        const data = response?.data?.data;
        const formattedData = data.map((item) => ({
          label: item.name,
          value: item._id,
        }));
        setAllEcommerceTags(formattedData);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading((prev) => ({ ...prev, allEcommerceTags: false }));
    }
  };

  const fetchchedProductDetail = async (id) => {
    try {
      setIsLoading((prev) => ({ ...prev, detail: true }));
      const response = await getSingleProductById(id);
      if (response?.data?.status === "success") {
        const data = response?.data?.data;

        if (data?.categoryId) {
          fetchchedAllSubCategories(data?.categoryId?._id);
        }
        if (data?.categoryId && data?.subCategoryId?.length > 0) {
          fetchchedAllSubSubCategories(
            data?.categoryId?._id,
            data?.subCategoryId[0]?._id,
          );
        }

        setInputValues((prev) => ({
          ...prev,
          images: data.images,
          name_en: data.name.en,
          name_ro: data.name.ro,
          type: data.type,
          category: data.categoryId?._id,
          subCategory: data.subCategoryId[0]?._id || "",
          subSubCategory: data.subSubCategoryId[0]?._id || "",
          brand: data.brand,
          quantity: data.quantity,
          sku: data.sku || "",
          description_en: data.description.en,
          description_ro: data.description.ro,
          price: data.price,
          discount: data.discount,
          profitMargin: data.profitMargin || 0,
          specification_en: decodeHtml(data.specification.en),
          specification_ro: decodeHtml(data.specification.ro),
          productType: data.isVariant ? "variant" : "normal",
          solutionType: data.solutionType || [],
          // tags: data.tags.map((item) => item?._id) || [],
        }));
        setAttributes(data.variantAttributes || []);
        setVariants(data.variants || []);
      } else {
        handleOpenSnackBar(response?.data?.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading((prev) => ({ ...prev, detail: false }));
    }
  };

  useEffect(() => {
    fetchchAllBrands();
    fetchchedAllCategories();
    dispatch(fetchSettings());
  }, []);

  useEffect(() => {
    if (inputValues.solutionType?.length > 0) {
      fetchchedAllEcommerceTags(inputValues.solutionType);
    }
  }, [inputValues.solutionType]);

  useEffect(() => {
    if (productPageType === "edit") {
      fetchchedProductDetail(productId);
    }
  }, [productPageType, productId]);

  const scrollToError = () => {
    if (errorRef.current) {
      errorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
      setTimeout(() => {
        if (errorRef.current) {
          errorRef.current.focus();
        }
      }, 300);
    }
  };

  // Check if the product is a variant
  const isVariant = useMemo(() => {
    return attributes.length > 0 && variants.length > 0;
  }, [attributes, variants]);

  // console.log(attributes, "attributes");
  // console.log(variants, "variants");
  // console.log(isVariant, "isVariant");

  const handleChangeProductType = (event) => {
    const value = event.target.value;
    setInputValues((prev) => ({
      ...prev,
      productType: value,
      price: 0,
      profitMargin: 0,
      discount: 0,
      quantity: 0,
      sku: "",
    }));
    setInputError((prev) => ({
      ...prev,
      price: "",
      profitMargin: "",
      discount: "",
      quantity: "",
      sku: "",
    }));
    setAttributes([]);
    setVariants([]);
  };

  const handleAddProduct = async () => {
    const { images, price, discount, profitMargin } = inputValues;

    // Reset errorRef before validation
    errorRef.current = null;

    // Validate the final input values
    const validate = addEditProductValidation(
      inputValues,
      setInputError,
      errorRef,
    );

    if (!validate) {
      scrollToError();
      return handleOpenSnackBar(
        "error",
        t("resolveTheIssues", { ns: "common" }),
      );
    }

    // attributes and variants validation

    if (inputValues?.productType === "variant") {
      if (attributes?.length === 0) {
        handleOpenSnackBar(
          "error",
          t("validation.pleaseAddAtLeastOneAttribute"),
        );
        return;
      }

      if (variants?.length === 0) {
        handleOpenSnackBar("error", t("validation.pleaseAddAtLeastOneVariant"));
        return;
      }

      const isValidVariants = validateVariants(variants);
      if (isValidVariants?.length > 0) {
        const message = isValidVariants
          .map((item) => t(item, { ns: "products" }))
          .join(", ");
        handleOpenSnackBar("error", message);
        return;
      }
    }

    // Calculate the final Product amount
    const finalAmount = calculateProductFinalPrice(
      price,
      discount,
      profitMargin,
    );

    const finalQuantity =
      inputValues.productType === "variant"
        ? overAllProductQuantity(variants)
        : inputValues.quantity;

    const payload = {
      // Images
      images: inputValues.images,
      coverImage: images[0],

      // Basic Information
      name: {
        en: inputValues.name_en,
        ro: inputValues.name_ro,
      },
      categoryId: inputValues.category,
      subCategoryId: [inputValues.subCategory],
      subSubCategoryId: [inputValues.subSubCategory],
      brand: inputValues.brand,
      type: inputValues.type,
      // createdBy: userData?.adminId,
      solutionType: inputValues.solutionType,
      // tags: inputValues.tags,

      // Pricing
      ...(productPageType === "add" && {
        price: price,
        discount: discount,
        finalPrice: finalAmount || 0,
        profitMargin: profitMargin || 0,
        // Quantity
        quantity: finalQuantity,
        initialQuantity: finalQuantity,
      }),

      ...(productPageType === "add" && !isVariant && { sku: inputValues.sku }),

      isVariant,
      // Variant
      ...(productPageType === "add" && {
        ...(isVariant && { variantAttributes: attributes }),
        ...(isVariant && {
          variants: variants.map((variant) => ({
            ...variant,
            finalPrice:
              calculateProductFinalPrice(
                variant.price,
                variant.discount,
                variant.profitMargin,
              ) || 0,
          })),
        }),
      }),
      // Tags
      // tags: inputValues.tags,

      // Description and Specification
      description: {
        en: inputValues.description_en,
        ro: inputValues.description_ro,
      },
      specification: {
        en: inputValues.specification_en,
        ro: inputValues.specification_ro,
      },
    };

    // console.log(payload, "payloadpayloadpayloadpayload");
    // return

    try {
      setIsLoading((prev) => ({ ...prev, addProduct: true }));

      let response;
      if (productPageType === "edit") {
        response = await updateProduct(productId, payload);
      } else {
        response = await createProduct(payload);
      }
      if (response?.data.status === "success") {
        handleOpenSnackBar("success", response?.data.message);
        dispatch(setActiveTab({ ...activeTab, productList: "product_list" }));
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading((prev) => ({ ...prev, addProduct: false }));
    }
  };

  const handleUpdateVariantStatus = async (variantId, event) => {
    if (!productId || !variantId) {
      handleOpenSnackBar("error", t("validation.missingProductIdOrVariantId"));
      return;
    }

    try {
      setIsLoading((prev) => ({ ...prev, updateVariantStatus: true }));
      const response = await updateVariantStatus(productId, variantId, {
        status: event.target.checked,
      });
      if (response?.data?.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading((prev) => ({ ...prev, updateVariantStatus: false }));
    }
  };

  const showNormalProductPricingPreview = useMemo(() => {
    return (
      inputValues.price > 0 &&
      inputValues.profitMargin >= 0 &&
      inputValues.discount >= 0 &&
      !isVariant
    );
  }, [
    inputValues.price,
    inputValues.profitMargin,
    inputValues.discount,
    isVariant,
  ]);

  if (isloading.allCategories || settingsLoading || isloading.detail) {
    return <LoadingContainer />;
  }

  return (
    <>
      <AppLoader isVisible={isloading.addProduct} />
      <PaperContainer
        title={
          productPageType === "add" ? t("addNewProduct") : t("editProduct")
        }
        subtitle={t("provideRequiredDetails")}
        showBackButton={true}
        onBack={() =>
          dispatch(setActiveTab({ ...activeTab, productList: "product_list" }))
        }
      >
        <Grid container spacing={2}>
          <Grid item md={12}>
            <Typography fontSize={20} lineHeight={"normal"} fontWeight={600}>
              {t("productMedia")}
            </Typography>
            <Typography
              variant="body2"
              fontWeight={400}
              color={"text.secondary"}
              lineHeight={"normal"}
              mt={1}
            >
              {t("productMediaDescription1")} {t("productMediaDescription2")}
            </Typography>
          </Grid>

          <Grid item xs={12} mt={2}>
            <ProductImages
              inputValues={inputValues}
              setInputValues={setInputValues}
              inputError={inputError}
              setInputError={setInputError}
            />
          </Grid>

          <BasicInformation
            inputValues={inputValues}
            setInputValues={setInputValues}
            allCategories={allCategories}
            allSubCategories={allSubCategories}
            allSubSubCategories={allSubSubCategories}
            allBrands={allBrands}
            inputError={inputError}
            setInputError={setInputError}
            fetchchedAllSubCategories={fetchchedAllSubCategories}
            fetchchedAllSubSubCategories={fetchchedAllSubSubCategories}
            allEcommerceTags={allEcommerceTags}
          />

          <Grid item xs={12}>
            <Typography fontSize={20} fontWeight={600}>
              {t("selectYourProductType")}
            </Typography>
            <Typography fontSize={14} color={"text.secondary"}>
              {t("selectYourProductTypeDescription")}
            </Typography>
            <FormControl>
              <RadioGroup
                row
                value={inputValues.productType}
                onChange={handleChangeProductType}
              >
                <FormControlLabel
                  value={"normal"}
                  control={<Radio />}
                  label={t("normalProduct")}
                  disabled={productPageType === "edit"}
                />

                <FormControlLabel
                  value={"variant"}
                  control={<Radio />}
                  label={t("variantProduct")}
                  disabled={productPageType === "edit"}
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {inputValues.productType === "normal" && (
            <Pricing
              productPageType={productPageType}
              errorRef={errorRef}
              inputValues={inputValues}
              setInputValues={setInputValues}
              inputError={inputError}
              setInputError={setInputError}
              vat={settings?.tax || DEFAULT_VAT_PERCENTAGE}
            />
          )}
        </Grid>

        {inputValues.productType === "variant" && (
          <ProductVariantManager
            productPageType={productPageType}
            attributes={attributes}
            setAttributes={setAttributes}
            variants={variants}
            setVariants={setVariants}
            vat={settings?.tax || DEFAULT_VAT_PERCENTAGE}
            onUpdateVariantStatus={handleUpdateVariantStatus}
          />
        )}

        {/* <ProductTags
          inputValues={inputValues}
          setInputValues={setInputValues}
          inputError={inputError}
          setInputError={setInputError}
          allEcommerceTags={allEcommerceTags}
        /> */}

        <DescriptionAndSpecification
          inputValues={inputValues}
          setInputValues={setInputValues}
          inputError={inputError}
          setInputError={setInputError}
        />

        <Stack
          mt={10}
          mb={3}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"flex-end"}
          gap={2}
        >
          {showNormalProductPricingPreview && (
            <Stack minWidth={120} height={40}>
              <GlobalButton
                styleProps={{
                  backgroundColor: "#FFF",
                  color: "primary.main",
                  border: "1px solid",
                  borderColor: "primary.main",
                }}
                btnText={t("preview")}
                hoverProperties={{
                  color: "primary.main",
                  backgroundColor: "#FFF",
                }}
                handleClickBtn={() => setPreviewOpen(true)}
              />
            </Stack>
          )}
          <Stack minWidth={120} height={40}>
            <GlobalButton
              styleProps={{
                backgroundColor: "#FFF",
                color: "primary.main",
              }}
              btnText={"discard"}
              hoverProperties={{
                color: "primary.main",
                backgroundColor: "#FFF",
              }}
              handleClickBtn={() => handleChangeTab("product_list")}
            />
          </Stack>
          <Stack minWidth={120} height={40}>
            <GlobalButton btnText={"save"} handleClickBtn={handleAddProduct} />
          </Stack>
        </Stack>
      </PaperContainer>
      <Preview
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        inputValues={inputValues}
        settings={settings}
      />
    </>
  );
};

export default AddEditProduct;
